






































































import CSlider from '~/components/shared/configurable/slider/CSlider.vue'
import { faEuroSign } from '@fortawesome/free-solid-svg-icons'
import { mapGetters, mapMutations, mapState } from 'vuex'
import UrlHistoryService from '~/services/url/history/UrlHistoryService'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import {
  SET_INSTALLMENTS_DOWNPAYMENT,
  SET_INSTALLMENTS_INSTALLMENT_AMOUNT,
  SET_INSTALLMENTS_NUMBER_OF_INSTALLMENTS
} from '~/store/modules/shared/classifieds/view/mutation-types'
import {
  INSTALLMENTS_DOWNPAYMENT_PARAM_NAME,
  INSTALLMENTS_NUM_OF_INSTALLMENTS_PARAM_NAME
} from '~/constants/finance/installments'
import { debounce } from '~/utils/function'
import InstallmentsService from '~/services/classified/finance/InstallmentsService'
import { mapDeps } from '~/plugins/dependency-container/utils'
import { formatNumber } from '~/utils/number'
import CFormErrorText from '~/components/shared/configurable/form/CFormErrorText.vue'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    CPrice,
    CSlider,
    CFormErrorText
  },
  computed: {
    icons: () => ({
      euroSign: faEuroSign
    }),
    hasValidDownpayment() {
      return this.downpaymentIsValid(this.$dep(InstallmentsService))
    },
    monthlyInstallmentAmount() {
      return this.getMonthlyInstallmentAmount(this.$dep(InstallmentsService))
    },

    ...mapState(CLASSIFIED_VIEW_NS, {
      downpayment: state => state.installments.downpayment,
      numberOfInstallments: state => state.installments.numberOfInstallments,
      maxInstallments: state =>
        state.classified.finance.options.maxInstallments,
      price: state => state.classified.finance.price,
      interestPercentage: state =>
        state.classified.finance.options.interestPercentage,
      minDownpayment: state => state.classified.finance.options.minDownpayment
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      downpaymentIsValid: 'downpaymentIsValid',
      getMonthlyInstallmentAmount: 'getMonthlyInstallmentAmount'
    }),
    ...mapDeps({
      historyService: UrlHistoryService
    }),
    sliderOptions: () => ({
      processStyle: {
        backgroundColor: '#1976d2'
      },
      tooltipStyle: {
        backgroundColor: '#1976d2'
      }
    }),
    downpaymentInvalidErrorMessage() {
      return `${this.$t('the::female')} ${this.$t(
        'downpayment'
      ).toLowerCase()} ${this.$t(
        'must be between'
      ).toLowerCase()} ${formatNumber(this.minDownpayment)}€ ${this.$t(
        'and'
      ).toLowerCase()} ${formatNumber(this.price)}€`
    }
  },
  mounted() {
    const {
      'installments-downpayment': installmentsDownpayment,
      'installments-num-of-installments': installmentsNumOfInstallments
    } = this.$route.query

    if (installmentsDownpayment) {
      this.setInstallmentsDownpayment(
        parseFloat(installmentsDownpayment as string)
      )
    }

    if (installmentsNumOfInstallments) {
      this.setInstallmentsNumberOfInstallments(
        parseFloat(installmentsNumOfInstallments as string)
      )
    }
  },
  methods: {
    ...mapMutations(CLASSIFIED_VIEW_NS, {
      setInstallmentsDownpayment: SET_INSTALLMENTS_DOWNPAYMENT,
      setInstallmentsNumberOfInstallments: SET_INSTALLMENTS_NUMBER_OF_INSTALLMENTS,
      setInstallmentsInstallmentAmount: SET_INSTALLMENTS_INSTALLMENT_AMOUNT
    }),
    handleNumberOfInstallmentsChange(numberOfInstallments: number) {
      this.setInstallmentsNumberOfInstallments(numberOfInstallments)
      this.historyService.replaceQueryParams({
        [INSTALLMENTS_NUM_OF_INSTALLMENTS_PARAM_NAME]: numberOfInstallments
      })
    },
    downpaymentChange: debounce(function(downpayment: string) {
      this.setInstallmentsDownpayment(parseFloat(downpayment))
      this.historyService.replaceQueryParams({
        [INSTALLMENTS_DOWNPAYMENT_PARAM_NAME]: downpayment
      })
    }, 1000),
    formatDownpayment(d: any) {
      return d.toString().substring(0, 6)
    }
  }
})
